function development() {
  return (['127.0.0.1', 'localhost'].indexOf(window.location.hostname) >= 0);
}

export default development;
